import { ArrowUpRight, Gauge } from "lucide-react";
import { SectionHead, Reveal } from "./Reveal";
import { useLang } from "../../i18n/LanguageContext";
import { PartnerWall } from "./PartnerWall";

export const AmperiProof = () => {
  const { t } = useLang();
  const a = t.amperi;
  return (
    <section id="amperi" className="relative bg-canvas bp-grid border-b border-technical py-20 sm:py-28" data-testid="amperi-section">
      <div className="mx-auto max-w-[1440px] px-5 sm:px-8">
        <SectionHead eyebrow={a.eyebrow} title={a.title} desc={a.desc} testid="amperi" />
        <PartnerWall />
        {a.marketsLabel && <p className="eyebrow mt-12" data-testid="amperi-markets-label">{a.marketsLabel}</p>}
        <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[rgba(22,24,27,0.12)] border border-technical" data-testid="amperi-proof">
          {a.proof.map((p, i) => (
            <Reveal key={p.url} delay={i * 0.07} className="bg-white">
              <a href={p.url} target="_blank" rel="noopener noreferrer" data-testid={`amperi-proof-${i}`} className="group flex h-full flex-col justify-between gap-5 p-6 sm:p-8 transition-colors duration-200 hover:bg-sand">
                <div>
                  <div className="flex items-start justify-between gap-3">
                    <span className="font-mono-tech text-[9.5px] uppercase tracking-[0.18em] text-red-brand">{p.role}</span>
                    <ArrowUpRight className="h-4 w-4 text-[#525964] transition-transform duration-200 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </div>
                  <h3 className="mt-3 font-display text-lg sm:text-xl font-bold tracking-tight text-ink group-hover:text-red-brand transition-colors">{p.name}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-[#525964]">{p.desc}</p>
                </div>
                <span className="font-mono-tech text-[10px] tracking-[0.15em] text-[#9ca3af]">{p.url.replace(/^https?:\/\/(www\.)?/, "").replace(/\/.*$/, "")}</span>
              </a>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}>
          <div className="mt-8 flex flex-col md:flex-row md:items-center gap-4 border-l-[3px] border-red-brand bg-white/60 px-5 py-4">
            <Gauge className="h-5 w-5 shrink-0 text-red-brand" />
            <p className="flex-1 text-sm leading-relaxed text-ink" data-testid="amperi-note">{a.note}</p>
            <div className="flex gap-2">
              {a.links.map((l) => (
                <a key={l.url} href={l.url} target="_blank" rel="noopener noreferrer" data-testid={`amperi-link-${l.label.replace(/\W+/g, "-")}`} className="chamfer-sm border border-technical px-3 py-1.5 font-mono-tech text-[10px] uppercase tracking-[0.15em] text-ink hover:border-red-brand hover:text-red-brand transition-colors">
                  {l.label}
                </a>
              ))}
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
};
